<template>
  <md-card>
    <md-card-header class="md-card-header-text md-card-header-green">
      <slot name="icon">
        <div class="card-icon">
          <md-icon>settings</md-icon>
        </div>
      </slot>
      <slot name="title">
        <h4 class="title">Config</h4>
      </slot>
    </md-card-header>
    <md-card-content class="md-layout">
      <div class="md-layout-item md-size-50">
        <md-field>
          <label>
            Consumer Android force version
            <span v-if="hasError('consumerAndroidForceVersion')" class="text-red">✗</span>
          </label>
          <md-input v-model="config.consumerAndroidForceVersion" :disabled="readonly" />
        </md-field>
      </div>
      <div class="md-layout-item md-size-50">
        <md-field>
          <label>
            Consumer Android latest version
            <span v-if="hasError('consumerAndroidLatestVersion')" class="text-red">✗</span>
          </label>
          <md-input v-model="config.consumerAndroidLatestVersion" :disabled="readonly" />
        </md-field>
      </div>
      <div class="md-layout-item md-size-50">
        <md-field>
          <label>
            Consumer iOS force version
            <span v-if="hasError('consumerIosForceVersion')" class="text-red">✗</span>
          </label>
          <md-input v-model="config.consumerIosForceVersion" :disabled="readonly" />
        </md-field>
      </div>
      <div class="md-layout-item md-size-50">
        <md-field>
          <label>
            Consumer iOS latest version
            <span v-if="hasError('consumerIosLatestVersion')" class="text-red">✗</span>
          </label>
          <md-input v-model="config.consumerIosLatestVersion" :disabled="readonly" />
        </md-field>
      </div>

      <div class="md-layout-item md-size-50">
        <md-field>
          <label>
            Merchant Amazon force version
            <span v-if="hasError('merchantAmazonForceVersion')" class="text-red">✗</span>
          </label>
          <md-input v-model="config.merchantAmazonForceVersion" :disabled="readonly" />
        </md-field>
      </div>
      <div class="md-layout-item md-size-50">
        <md-field>
          <label>
            Merchant Amazon latest version
            <span v-if="hasError('merchantAmazonLatestVersion')" class="text-red">✗</span>
          </label>
          <md-input v-model="config.merchantAmazonLatestVersion" :disabled="readonly" />
        </md-field>
      </div>
      <div class="md-layout-item md-size-50">
        <md-field>
          <label>
            Merchant Android force version
            <span v-if="hasError('merchantAndroidForceVersion')" class="text-red">✗</span>
          </label>
          <md-input v-model="config.merchantAndroidForceVersion" :disabled="readonly" />
        </md-field>
      </div>
      <div class="md-layout-item md-size-50">
        <md-field>
          <label>
            Merchant Android latest version
            <span v-if="hasError('merchantAndroidLatestVersion')" class="text-red">✗</span>
          </label>
          <md-input v-model="config.merchantAndroidLatestVersion" :disabled="readonly" />
        </md-field>
      </div>
      <div class="md-layout-item md-size-50">
        <md-field>
          <label>
            Merchant iOS force version
            <span v-if="hasError('merchantIosForceVersion')" class="text-red">✗</span>
          </label>
          <md-input v-model="config.merchantIosForceVersion" :disabled="readonly" />
        </md-field>
      </div>
      <div class="md-layout-item md-size-50">
        <md-field>
          <label>
            Merchant iOS latest version
            <span v-if="hasError('merchantIosLatestVersion')" class="text-red">✗</span>
          </label>
          <md-input v-model="config.merchantIosLatestVersion" :disabled="readonly" />
        </md-field>
      </div>

      <div class="md-layout-item md-size-50">
        <md-field>
          <label>
            Merchant tablet upgrade message
            <span v-if="hasError('merchantTabletUpgradeMessage')" class="text-red">✗</span>
          </label>
          <md-textarea
            v-model="config.merchantTabletUpgradeMessage"
            :disabled="readonly"
            style="padding: 20px 0px 0px 0px"
          />
        </md-field>
      </div>
      <div class="md-layout-item md-size-50">
        <md-field>
          <label>
            Merchant tablet upgrade start date
            <span v-if="hasError('merchantTabletUpgradeStartDate')" class="text-red">✗</span>
          </label>
          <md-input
            v-model="config.merchantTabletUpgradeStartDate"
            :disabled="readonly"
            type="date"
            :class="{
              'hide-blank-text': !config.merchantTabletUpgradeStartDate
            }"
          />
        </md-field>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
export default {
  name: "config-card",
  props: {
    config: {
      type: Object,
      default() {
        return {};
      }
    },
    readonly: {
      type: Boolean,
      default() {
        return false;
      }
    },
    attributeErrors: {
      type: Object,
      default() {
        return {};
      }
    },
  },
  methods: {
    hasError(attrName) {
      return Object.keys(this.attributeErrors).includes(attrName);
    },
  },
}
</script>

<style lang="scss" scoped>
  .hide-blank-text {
    -webkit-text-fill-color: white !important;
    &:focus {
      -webkit-text-fill-color: #3c4858 !important;
    }
  }
  .text-red {
    color: red !important;
  }
</style>
